<template>
    <div id="app">
        <div id="masthead">
            <div class="brand">Journey North</div>
            <button
                aria-expanded="false"
                aria-controls="nav-primary"
                id="menu-toggle"
                class="menu-toggle"
            >
                <div class="menu-icon">
                    <div class="one">&nbsp;</div>
                    <div class="two">&nbsp;</div>
                    <div class="three">&nbsp;</div>
                </div>
            </button>
            <div id="nav">
                <ul>
                    <li><router-link to="/">Home</router-link></li>
                    <li><router-link to="/about">About</router-link></li>
                    <li v-if="!loggedIn">
                        <router-link to="/register"
                            >Become a Citizen&nbsp;Scientist</router-link
                        >
                    </li>
                    <li v-if="!loggedIn">
                        <router-link to="/login">Log&nbsp;In</router-link>
                    </li>
                    <li v-if="loggedIn">
                        <button @click="logout">
                            Log&nbsp;Out
                        </button>
                    </li>
                    <li v-if="loggedIn">
                        <router-link to="/password/update"
                            >Change&nbsp;Password</router-link
                        >
                    </li>
                    <li v-if="loggedIn">
                        <router-link to="/profile/update"
                            >Update&nbsp;Profile</router-link
                        >
                    </li>
                    <li>
                        <router-link to="/report"
                            >Report&nbsp;Sighting</router-link
                        >
                    </li>
                    <li>
                        <router-link to="/sightings"
                            >My&nbsp;Sightings</router-link
                        >
                    </li>
                    <li>
                        <router-link to="/sightings/all"
                            >Explore&nbsp;Data</router-link
                        >
                    </li>
                    <li>
                        <router-link to="/contact">Contact&nbsp;Us</router-link>
                    </li>
                    <li>
                        <router-link to="/request-data"
                            >Request&nbsp;Data</router-link
                        >
                    </li>
                </ul>
            </div>
        </div>
        <div class="wrapper">
            <router-view />
        </div>
    </div>
</template>

<script>
import { authComputed } from './vuex/helpers.js'

export default {
    computed: {
        ...authComputed
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
        }
    }
}
</script>

<style lang="scss">
@import './assets/styles/global.scss';
</style>
